import React, { useState, useEffect } from "react";
import { View, TouchableOpacity, Text } from "react-native";

import IntegrationsHelper, { INTEGRATION_KEYS } from "../IntegrationsHelper";

import styles from "./integrationStyles";

import ManaMinutesDuration from "../../common/ManaMinutesDuration";
import IntegrationDetails from "./IntegrationDetails";
import { hasItems } from "../../../../helpers/utils";
import IntegrationSourceIcon from "../common/IntegrationSourceIcon";
import RoundCheckbox from "../../common/RoundCheckbox";
import ArrowDownIcon from "../../common/icons/ArrowDownIcon";
import IntegrationRuleDetails from "./IntegrationRuleDetails";
import appStyles from "../../../appStyles";

export default function RuleWrapper(props) {
  const {
    controller,
    data,
    highlight = false,
    style = {},
    showHours = false,
    isSelected = false,
    useRadioButton = false,
    hasDetails = true,
    hasRules = false,
    showSelector = false,
    hasDropdownArrow = false,
    onLongPress = () => {},
    onToggle,
    onContainerPress, // Track details: expand container
  } = props;

  const source = data?.source || {};
  const sourceName = source?.name;

  const displayDetailsPanel =
    hasDetails && sourceName !== INTEGRATION_KEYS.health;

  const [showDetails, setShowDetails] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [integration, setIntegration] = useState({});

  useEffect(() => {
    const rulesModel = IntegrationsHelper.getRuleOptions(data) || {};

    // Matching Element
    let matching_element = null;
    if (data.id_element != null) {
      matching_element = (controller?.state.elements || []).find(
        (e) => e.id == data.id_element,
      );
    }

    setShowRules(data.isExpanded);
    setIntegration({
      ...data,
      name: data.name,
      matching_rule: data.id,
      element: matching_element,
      rule: rulesModel.defaultRule,
      rules: rulesModel.rules,
    });
  }, [data, isSelected]);

  // ------------------------------------- METHODS -------------------------------------
  onSelectedRuleChanged = (rule) => {
    const newIntegration = {
      ...integration,
      rule,
    };

    // Update selected rule
    setIntegration(newIntegration);

    // Trigger toggle with updated rule
    if (onToggle) onToggle(newIntegration, false);
  };

  const toggleElementSelection = () => {
    if (onContainerPress) onContainerPress();
    // Integrations matching rules
    if (hasRules) {
      setShowRules(!showRules);
    }

    // For Delete page
    if (onToggle) {
      onToggle(integration, isSelected);
    } else {
      if (!displayDetailsPanel) return;
      setShowDetails(!showDetails);
    }
  };

  return (
    <TouchableOpacity
      onLongPress={onLongPress}
      onPress={toggleElementSelection}
      style={[
        styles.container,
        showRules && { backgroundColor: "#FFF" },
        highlight && styles.highlight,
        style,
      ]}
    >
      <View style={[styles.row, styles.main]}>
        <IntegrationSourceIcon
          data={integration}
          isCollapsed={!showDetails}
          showCollapseIcon={
            displayDetailsPanel && hasItems(integration?.details)
          }
        />

        {/* Name */}
        <View style={{ flex: 1, marginLeft: 7 }}>
          <Text
            style={styles.integrationName}
            numberOfLines={1}
            title={data.name}
          >
            {data.name}
          </Text>
        </View>

        {/* Right Icons */}
        {hasDropdownArrow ? (
          <ArrowDownIcon
            isCollapsed={!showRules}
            styles={appStyles.iconContainer}
          />
        ) : showSelector ? (
          <RoundCheckbox
            {...(useRadioButton
              ? { isRadioChecked: isSelected }
              : { checked: isSelected })}
            onValueChange={toggleElementSelection}
            size={16}
          />
        ) : !showHours ? null : (
          <View style={{ marginRight: 20 }}>
            <ManaMinutesDuration minutes={source.duration} />
          </View>
        )}
      </View>

      {showRules ? (
        <IntegrationRuleDetails
          {...props}
          integration={integration}
          onSelectedRuleChanged={onSelectedRuleChanged}
        />
      ) : null}
      {showDetails ? (
        <IntegrationDetails details={integration.details} />
      ) : null}
    </TouchableOpacity>
  );
}
